import React from 'react';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        const { t } = this.props;
        if (this.state.hasError) {
            return (
                <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'var(--font-body)', color: 'var(--text-primary)', background: 'var(--bg-base)', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '4rem', color: 'var(--orange-light)', letterSpacing: '0.05em', marginBottom: '1rem' }}>{t('error.somethingWentWrong')}</h1>
                    <p style={{ maxWidth: '600px', margin: '0 auto 2rem', color: 'var(--text-muted)', lineHeight: 1.6 }}>
                        {t('error.unexpectedError')}
                    </p>
                    <button
                        onClick={() => window.location.href = '/'}
                        style={{ padding: '0.75rem 2rem', background: 'var(--orange)', color: '#fff', border: 'none', borderRadius: 'var(--radius-sm)', fontFamily: 'var(--font-heading)', fontWeight: 600, fontSize: '1rem', cursor: 'pointer', textTransform: 'uppercase' }}
                    >
                        {t('error.goBackToHome')}
                    </button>

                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <details style={{ marginTop: '2rem', whiteSpace: 'pre-wrap', textAlign: 'left', background: 'var(--bg-card)', padding: '1rem', borderRadius: 'var(--radius-md)', border: '1px solid var(--border)', maxWidth: '800px', width: '100%' }}>
                            <summary style={{ cursor: 'pointer', color: 'var(--orange-light)', outline: 'none', marginBottom: '0.5rem' }}>{t('error.errorDetails')}</summary>
                            <code style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                                {this.state.error.toString()}
                                <br />
                                {this.state.errorInfo?.componentStack}
                            </code>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default withTranslation()(ErrorBoundary);
